import React from "react"
import styles from './Contact.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

const EMAIL = 'julian.capilla82@gmail.com'
const LINKEDIN_URL = 'https://www.linkedin.com/in/julian-capilla-b2a24359/'

export default function Contact() {
    return (
        <div className={styles.contact}>
            <h3 className={styles.title}>Let's work together</h3>
            <p>
                Have a project in mind, or just want to talk through an idea? I'm always happy
                to hear from potential clients and collaborators — reach out and I'll get back
                to you as soon as I can.
            </p>
            <div className={styles.links}>
                <a className={styles.linkCard} href={`mailto:${EMAIL}`}>
                    <FontAwesomeIcon icon={faEnvelope}/>
                    <span>{EMAIL}</span>
                </a>
                <a className={styles.linkCard} href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faExternalLinkAlt}/>
                    <span>Connect on LinkedIn</span>
                </a>
            </div>
        </div>
    )
}
